import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FwcDatePicker, FwcTooltip } from '../../../../fwc-lib.js';
import moment from 'moment';
import { FwcHero } from '../../../../fwc-lib.js';
import { SAEBaseComponent } from '../../../common/components/sae-base.component';
import { WcsApiService } from '../../../common/services/wcs-api-service';
import { UserCacheService } from '../../../common/services/user-cache.service';
import { DataService } from '../../services/data.service';
import { SaeLoginService } from '../sae-login/sae-login.service';
import { AppConstants } from './../../constants/app-constants';
import { SaeRegistrationService } from './sae-registration.service';
import { ValidatorService } from '../../services/validator.service';
import { lastValueFrom } from 'rxjs';


@Component({
    selector: 'sae-registration',
    templateUrl: './sae-registration.component.html',
    styleUrls: ['./sae-registration.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SaeRegistrationComponent extends SAEBaseComponent implements OnInit {
  @Input() content: any;
  @Output() updateUserCache: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('fwc-date-picker', { static: false }) datePicker: ElementRef;
  createForm!: UntypedFormGroup;
  submitted = false;
  createMask = true;
  retypeMask = true;
  passwordValidateError = false;
  emailValidateError = false;
  passwordMatchError = false;
  emailMatchError = false;
  dobError = false;
  dob: any;
  ruleLowerMet = false;
  rule8characterMet = false;
  ruleUpperMet = false;
  ruleSpecialMet = false;
  ruleNumberMet = false;
  showPasswordRules = false;
  ruleUpperCharMet = false;
  contents: any;
  participationId: string;
  microSiteID: string;
  campusMicrosite: boolean = false;
  studentIDPatteren: any;
  registrationOutput = {
    email: '',
    confirmEmail: '',
    password: '',
    retypePassword: '',
    studentId: '',
    dob: ''
  };
  loginOutput = {
    clientCorrelationId: '',
    userId: '',
    token: ''
  };
  displaySpinner: boolean = false;
  universityData: any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public saeRegistrartionService: SaeRegistrationService,
    public dataService: DataService,
    public saeLoginService: SaeLoginService,
    public userCacheService: UserCacheService,
    private route: ActivatedRoute,
    public wcsApiService: WcsApiService,
    private validatorSvc: ValidatorService,
    public router: Router
   
  ) {
    super(wcsApiService);
    const fwcHero = new FwcHero();
    fwcHero.build();
    const fwcTooltip = new FwcTooltip();
    fwcTooltip.build();
    let participationIdfromCache = this.userCacheService.getUserData(AppConstants.MICROSITE_STORY_ID);
    let StudentIDPattrenFromCache=this.userCacheService.getUserData(AppConstants.STUDENT_ID_PATTEREN);
    if(StudentIDPattrenFromCache){
       this.studentIDPatteren=StudentIDPattrenFromCache;
    }else{
      this.studentIDPatteren='^[A-Za-z0-9!_@./#&+-]*$';
    }
    const micrositeId = this.userCacheService.getUserData(AppConstants.MICROSITE_ID);
    if(micrositeId){
      this.microSiteID = micrositeId;
    }
     const participationId = this.userCacheService.getUserData(AppConstants.PARTICIPATION_ID);
     if(participationId){
      this.participationId = participationId;
     }
   // const participationId = participationIdfromCache.toString();
    this.participationId = this.route.snapshot.paramMap.get('id');
  }

  async ngOnInit(): Promise<void> {
    const fwcDatePicker = new FwcDatePicker();
    fwcDatePicker.build();
    this.createForm = this.formBuilder.group({
      email: ['', [Validators.required, this.validatorSvc.emailValidation()]],
      confirmEmail: ['', [Validators.required, this.validatorSvc.emailValidation()]],
      usrSecret: ['', Validators.required],
      retypePassword: ['', Validators.required],
      studentId: ['', Validators.required],
      dob: ['', Validators.required]
    });
    await this.loadWCSData('login');
    if (this.wcsdata) {
      this.contents = this.wcsdata;
    }
    
    this.campusMicrosite = this.route.snapshot.paramMap.get('storyId') ? true : false;
  }
  get form(): { [p: string]: AbstractControl } { return this.createForm.controls; }
  
  onCreateSubmit(): void {
    // this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: null });
    if(this.campusMicrosite) {
        let micrositeStoryID = this.userCacheService.getUserData('MICROSITE_STORY_ID');
		this.dataService.doAnnouncement(null);
	    this.submitted = true;
	    if (!this.form.email.errors && !this.form.usrSecret.errors && !this.form.studentId.errors && !this.form.dob.errors && this.validateFields()) {
	      const requestObj = {
	        emailAddress: this.form.email.value,
	        usrSecret: this.form.usrSecret.value,
	        studentId: this.form.studentId.value,
	        dateOfBirth: this.form.dob.value,
	        micrositeId: this.route.snapshot.paramMap.get('storyId'),
	        storyId: micrositeStoryID.toString()
	      };
	       this.displaySpinner = true;
	       this.saeRegistrartionService.createMicrositeUser(requestObj).subscribe(data => {
	        this.displaySpinner = false;
	        const response: any = data;
	        if (response.errorCode === AppConstants.INPUT_STATUS) {
	          this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_101});
	        }
	        if (response.errorCode === AppConstants.ROSTER_NOT_FOUND_STATUS) {
	          this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_102 });
	        }
	        if (response.errorCode === AppConstants.REGISTRATION_ERROR_STATUS) {
	          this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_103});
	        }
	        if (response.errorCode === AppConstants.USER_EXISTS_STATUS) {
	          this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_104});
	        }
	        if (response.errorCode === AppConstants.SYSTEM_STATUS) {
	          this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_105 });
	        }
	        if (response.errorCode === AppConstants.ENROLL_STATUS) {
	          this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_106 });
	        }
	        if (response.errorCode === AppConstants.USERNAME_PASS_PARTIAL_MATCH_STATUS) {
	          this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_107 });
	        }
	        else if (response.status === AppConstants.SUCCESS_STATUS) {
	          // this.registrationOutput.email = response.email;
	          // this.registrationOutput.password = response.password;
	          // this.registrationOutput.studentId = response.studentId;
	          // this.registrationOutput.dob = response.dob;
	          // this.displaySpinner = true;
	          // this.saeLoginService.authenticate(this.form.email.value, this.form.usrSecret.value).subscribe(data => {
	          //   this.displaySpinner = false;
	          //   const loginResponse: any = data;
	          //   if (loginResponse.status === AppConstants.FAILURE_STATUS) {
	          //     this.dataService.doAnnouncement({ topic: AppConstants.LOGIN_FAILED, message: this.contents.errorCode.FAILURE});
	          //   } else if (loginResponse.status === AppConstants.SUCCESS_STATUS) {
	          //     this.loginOutput.userId = loginResponse.userId;
	          //     this.loginOutput.token = loginResponse.token;
	          //     this.updateUserCache.emit(this.loginOutput);
            //     this.userCacheService.setUserData('LOGIN_USER_NAME', loginResponse.userName);
	          //     this.userCacheService.setUserData('LOGIN_EMAIL', this.form.email.value);
	          //   }
	          // }, err => {
	          //   this.displaySpinner = false;
	          //   console.log('error occurred while authenticating', err);
	          // });
	        
            this.resetForm();
           this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_SUCCESS, message: 'Registration successful. Pleasee login with Your Password' });
          }
	      }, err => {
	        this.displaySpinner = false;
	        console.log('error occurred while Registration', err);
	        this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_105});
	      });
	    } 
    
    }
    else {
    this.dataService.doAnnouncement(null);
    this.submitted = true;
    if (!this.form.email.errors && !this.form.usrSecret.errors && !this.form.studentId.errors && !this.form.dob.errors && this.validateFields()) {
      const requestObj = {
        emailAddress: this.form.email.value,
        usrSecret: this.form.usrSecret.value,
        studentId: this.form.studentId.value,
        dateOfBirth: this.form.dob.value,
        participationId: this.participationId
      };
      this.displaySpinner = true;
      this.saeRegistrartionService.createUser(requestObj).subscribe(data => {
        this.displaySpinner = false;
        const response: any = data;
        if (response.errorCode === AppConstants.INPUT_STATUS) {
          this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_101});
        }
        if (response.errorCode === AppConstants.ROSTER_NOT_FOUND_STATUS) {
          this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_102 });
        }
        if (response.errorCode === AppConstants.REGISTRATION_ERROR_STATUS) {
          this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_103});
        }
        if (response.errorCode === AppConstants.USER_EXISTS_STATUS) {
          this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_104});
        }
        if (response.errorCode === AppConstants.SYSTEM_STATUS) {
          this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_105 });
        }
        if (response.errorCode === AppConstants.ENROLL_STATUS) {
          this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_106 });
        }
        if (response.errorCode === AppConstants.USERNAME_PASS_PARTIAL_MATCH_STATUS) {
          this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_107 });
        }
        else if (response.status === AppConstants.SUCCESS_STATUS) {
          // this.registrationOutput.email = response.email;
          // this.registrationOutput.password = response.password;
          // this.registrationOutput.studentId = response.studentId;
          // this.registrationOutput.dob = response.dob;
          // this.displaySpinner = true;
          // this.saeLoginService.authenticate(this.form.email.value, this.form.usrSecret.value).subscribe(data => {
          //   this.displaySpinner = false;
          //   const loginResponse: any = data;
          //   if (loginResponse.status === AppConstants.FAILURE_STATUS) {
          //     this.dataService.doAnnouncement({ topic: AppConstants.LOGIN_FAILED, message: this.contents.errorCode.FAILURE});
          //   } else if (loginResponse.status === AppConstants.SUCCESS_STATUS) {
          //     this.loginOutput.userId = loginResponse.userId;
          //     this.loginOutput.token = loginResponse.token;
          //     this.updateUserCache.emit(this.loginOutput);
          //   }
          // }, err => {
          //   this.displaySpinner = false;
          //   console.log('error occurred while authenticating', err);
          // }); 
           this.resetForm();
           this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_SUCCESS, message: 'Registration successful. Please login with Your Password' });
        }
      }, err => {
        this.displaySpinner = false;
        console.log('error occurred while Registration', err);
        this.dataService.doAnnouncement({ topic: AppConstants.REGISTRATION_FAILED, message: this.contents.errorCode.REG_ERR_105});
      });
    } 
    }
  }
  resetForm(): void {
    this.createForm.reset();
    this.submitted = false;
    this.dob = null;
    this.dobError = false;
    this.passwordValidateError = false;
    this.passwordMatchError = false;
    this.emailValidateError = false;
    this.emailMatchError = false;
    this.ruleLowerMet = false;
    this.rule8characterMet = false;
    this.ruleUpperMet = false;
    this.ruleSpecialMet = false;
    this.ruleNumberMet = false;
    this.ruleUpperCharMet = false;
    this.showPasswordRules = false;
    
    // Reset the date picker component
    setTimeout(() => {
      const datePickerElement = document.querySelector('fwc-date-picker');
      if (datePickerElement) {
        const inputElement = datePickerElement.shadowRoot?.querySelector('input') || 
                            datePickerElement.querySelector('input');
        if (inputElement) {
          (inputElement as HTMLInputElement).value = '';
        }
        (datePickerElement as any).value = '';
      }
    }, 0);
  }
  updateDob(e): void {
    this.dob = moment(e.detail).format('MM/DD/YYYY');
    const dateOfBirth = 'dob';
    this.createForm.controls[dateOfBirth].setValue(this.dob);
    this.validateDate(this.dob);
  }
  validateDate(e): void {
    const dateOfBirth = 'dob';
    const isInRange = this.isDateInRange(e);
    const isDateValid = moment(e, 'MM/DD/YYYY', true).isValid();
    if (!isDateValid || !isInRange) {
      this.createForm.controls[dateOfBirth].setErrors({ 'invalid date': true });
      this.createForm.controls[dateOfBirth].setValue('');
    } else {
      this.createForm.controls[dateOfBirth].setErrors(null);
    }
  }
  isDateInRange(date): boolean {
    return moment(date, 'MM/DD/YYYY').isAfter('01/01/1922');
  }
  blurEvent(e): void {
    this.updateDob(e);
  }
  passwordValidation(password): boolean {
    // one lower char, one upper char, one digit, one special character from [$!@*?|], can contain characters from before mentioned only, min = 8, max = 20
    const generalRules = (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$!@*?|])[A-Za-z\d$!@*?|]{12,20}$/);
    // cannot contain whitespaces
    const validateNoSpace = /^\S*$/;
    if (generalRules.test(password) && validateNoSpace.test(password) && this.validateRepeatedCharacter(password)) {
      return true;
    } else {
      return false;
    }
  }
  validateRepeatedCharacter(password): boolean {
    const str: string = password;
    if (str != null) {
      const len: number = str.length;
      const newstr: Array<string> = [];
      for (let i = 0; i < len; i++) {
        newstr[i] = str.charAt(i);
      }
      for (let j = 0; j < len; j++) {
        if ((newstr[j] === newstr[j + 1]) && (newstr[j + 1] === newstr[j + 2])) {
          return false;
        }
      }
    }
    return true;
  }
  // isValidEmailAddress(email: any): boolean {
  //   const regex = new RegExp('^[\\w-_\\.+]*[\\w-_\\.]\\@([\\w]+\\.)+[\\w]+[\\w]$');
  //   return regex.test(email);
  // }

  passwordMatch(Password: any, retypePassword: any): boolean {
    if (Password != null && retypePassword != null && Password === retypePassword) { return true; }
    else { return false; }
  }

  emailMatch(email: any, ConfirmEmail: any): boolean {
    if (email != null && ConfirmEmail != null && email === ConfirmEmail) {
      return true;
    }
    else { return false; }
  }
  dobvalidation(dob: any): boolean {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      --age;
    }
    if (age < 14) { return false; }
    else { return true; }
  }

  validateFields(): boolean {
    let returnVal = true;
    this.passwordMatchError = false;
    this.emailValidateError = false;
    this.emailMatchError = false;
    this.passwordValidateError = false;
    this.dobError = false;

    if (!this.passwordMatch(this.form.usrSecret.value, this.form.retypePassword.value)) {
      this.passwordMatchError = true;
      returnVal = false;
    }
    if (!this.emailMatch(this.form.email.value, this.form.confirmEmail.value)) {
      this.emailMatchError = true;
      returnVal = false;
    }
    // if (!this.isValidEmailAddress(this.form.email.value)) {
    //   this.emailValidateError = true;
    //   returnVal = false;
    // }
    if (!this.passwordValidation(this.form.usrSecret.value)) {
      this.passwordValidateError = true;
      returnVal = false;
    }
    if (!this.dobvalidation(this.form.dob.value)) {
      this.dobError = true;
      returnVal = false;
    }
    return returnVal;
  }
  checkPasswordRules(): void {
    // pass input value here and check against password rules
    this.showPasswordRules = true;
    this.ruleLowerMet = false;
    this.rule8characterMet = false;
    this.ruleUpperMet = false;
    this.ruleSpecialMet = false;
    this.ruleNumberMet = false;
    this.ruleUpperCharMet = false;

    if (/[0-9]/g.test(this.form.usrSecret.value)) {
      this.ruleNumberMet = true;
    }
    if (/[a-z]/g.test(this.form.usrSecret.value)) {
      this.ruleLowerMet = true;
    }
    if (/[A-Z]/g.test(this.form.usrSecret.value)) {
      this.ruleUpperMet = true;
    }
    if (/[$!@*?|]/g.test(this.form.usrSecret.value)) {
      this.ruleSpecialMet = true;
    }
    if (/.{12,}/.test(this.form.usrSecret.value)) {
      this.rule8characterMet = true;
    }
    if (/[A-Z]/g.test(this.form.usrSecret.value)) {
      this.ruleUpperCharMet = true;
    }
  }
  onKey(e): void {
    const regxStr = new RegExp('^[0-9a-zA-Z$!@*?|]*$');
    if (!regxStr.test(e.key)) {
      e.preventDefault();
    }
  }

}
